import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { hasRole, landingPage } from '../../config/permissions';

// Route-level role gate. The API enforces the same rule server-side; this
// keeps people off pages that would only show them errors.
const RequireRole = ({ minRole, children }) => {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" />;
  }

  if (!hasRole(user.role, minRole)) {
    return <Navigate to={`/dashboard/${landingPage(user.role)}`} replace />;
  }

  return children;
};

export default RequireRole;
